<template>
  <div class="video-wrapper">
    <video :src="videoSourceWithPoster" v-if="videoSource" :controls="options.controls" :autoplay="options.autoplay" :muted="options.muted" :style="videoStyle" :poster="videoSourceWithPoster" playsinline @click="onClick($event)" ref="videoElement" @playing="onPlaying" @pause="onPause"></video>

    <div style="position: absolute;padding: 1rem;" @click="playVideo($event)" v-if="!options.controls" v-show="!playing">
      <i class="fas fa-play fa-2x" style="color: var(--light);"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "dynamicVideo",

  props: {
    fileId: String,
    fileUrl: String,
    options: {
      type: Object,
      default: function () {
        return {
          controls: false,
          autoplay: false,
        };
      },
    },
    videoStyle: String,
  },

  data() {
    return {
      videoSource: null,
      playing: false
    };
  },

  computed: {
    videoSourceWithPoster() {
      return this.videoSource + "#t=0.1";
    },
  },

  async mounted() {
    if (this.fileId) {
      if (this.device && this.device.platform == "iOS") {
        this.videoSource = await this.$store.dispatch("getFileUrl", this.fileId);
      } else {
        this.videoSource = this.baseUrl + "/file/" + this.fileId;
      }
    }
    else if (this.fileUrl) {
      this.videoSource = this.fileUrl
    }
  },
  watch: {
    fileId: async function (value) {
      if (this.device && this.device.platform == "iOS") {
        this.videoSource = await this.$store.dispatch("getFileUrl", value);
      } else {
        this.videoSource = this.baseUrl + "/file/" + value;
      }
    },
  },

  methods: {
    onClick(event) {
      if (this.playing) {
        event.stopPropagation()
        this.$refs.videoElement.pause()
      }
    },
    play() {
      this.$refs.videoElement.play()
    },
    onPlaying() {
      this.playing = true
      this.$emit('playing')
    },
    onPause() {
      this.playing = false
      this.$emit('pause')
    },
    playVideo(event) {
      event.stopPropagation()
      this.$refs.videoElement.play()
    },
  }
};
</script>

<style scoped>
.video-wrapper {
  display: grid;
  place-items: center;
}

video {
  max-width: 100%;
}
</style>
